<div class="container">
  <div class="text-center mt-5">
    <h1>{{'ORDER_DETAILS.QR.MESSAGE' | transloco}}</h1>
    <div class="d-inline-block">
      <qrcode [qrdata]="id" [width]="400" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
    <h1>{{'ORDER_DETAILS.QR.SCAN_ME' | transloco}}</h1>
  </div>
</div>